export enum FragePflegegrad {
  PFLEGEGRAD0 = 'PFLEGEGRAD0',
  PFLEGEGRAD1 = 'PFLEGEGRAD1',
  PFLEGEGRAD2 = 'PFLEGEGRAD2',
  PFLEGEGRAD3 = 'PFLEGEGRAD3',
  PFLEGEGRAD4 = 'PFLEGEGRAD4',
  PFLEGEGRAD5 = 'PFLEGEGRAD5',
}
